import { useState } from 'react';
import { ORIGIN_TABLE_MAP } from 'features/daily-plan/constants';
import { useFeatureFlags } from 'providers/FeatureFlagsProvider';
import { SelectionType } from 'UI/constants/defaults';
import { Endpoints } from 'UI/constants/endpoints';
import { ContactEntityMapping, ENTITY_TYPE_ID_MAP } from 'UI/constants/entityTypes';
import { FeatureFlags } from 'UI/constants/featureFlags';

const getEntityTypePerItem = ({ table, item }) => {
  const itemName = item.type?.toLowerCase();
  const OBJECT_TO_EXTRACT_BY_ENTITY_TABLE = {
    [ORIGIN_TABLE_MAP.Candidates]: ENTITY_TYPE_ID_MAP[itemName],
    [ORIGIN_TABLE_MAP.Contacts]: ENTITY_TYPE_ID_MAP[ContactEntityMapping[item.type_id]],
    [ORIGIN_TABLE_MAP.Companies]: ENTITY_TYPE_ID_MAP[itemName],
    [ORIGIN_TABLE_MAP.ResumeSearch]: ENTITY_TYPE_ID_MAP[itemName]
  };

  return OBJECT_TO_EXTRACT_BY_ENTITY_TABLE[table];
};

// TODO: Adjust endpoints when backend team adds support for multiple notes creation
const ENDPOINT_TO_ENTITY_TYPE_MAP = {
  [ORIGIN_TABLE_MAP.Candidates]: Endpoints.Candidates,
  [ORIGIN_TABLE_MAP.Contacts]: Endpoints.Names,
  [ORIGIN_TABLE_MAP.Companies]: Endpoints.Companies,
  [ORIGIN_TABLE_MAP.ResumeSearch]: Endpoints.Candidates
};

export const useNoteDrawerManager = ({ table, selectedItems = [], selectionType = 'include' }) => {
  const { checkIfFeatureFlagEnabled } = useFeatureFlags();
  const canCreateMultipleNotes =
    checkIfFeatureFlagEnabled(FeatureFlags.MultipleNotesFromList) &&
    selectionType === SelectionType.Include;
  const [isNoteDrawerOpen, setIsNoteDrawerOpen] = useState(false);
  const handleOpenNoteDrawer = () => setIsNoteDrawerOpen(true);
  const handleCloseNoteDrawer = () => setIsNoteDrawerOpen(false);
  const noteEndpoint = ENDPOINT_TO_ENTITY_TYPE_MAP[table];

  const formattedSelectedItems = selectedItems?.map(item => {
    return {
      entityId: item.id,
      entityTypeId: getEntityTypePerItem({ table, item })
    };
  });

  return {
    canCreateMultipleNotes,
    formattedSelectedItems,
    handleCloseNoteDrawer,
    handleOpenNoteDrawer,
    isNoteDrawerOpen,
    noteEndpoint
  };
};
